import React from 'react';
import PropTypes from 'prop-types';
import { Popup, Icon, Label, Header, List, Segment } from 'semantic-ui-react';
import { CLONE_STATUSES } from './cloneStatusConfig';

/**
 * CloneStatusLegend
 *
 * Non-color affordance for the voice-cloning pipeline badges. Same
 * structure / styling as VariationStatusLegend so the two pipelines feel
 * like siblings.
 *
 *   <CloneStatusLegend compact />  → info-icon with click Popup
 *   <CloneStatusLegend />          → inline Segment
 */

const LegendRows = () => (
  <List relaxed="very" style={{ margin: 0 }}>
    {CLONE_STATUSES.map((s) => (
      <List.Item
        key={s.key}
        style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
      >
        <Label
          size="tiny"
          color={s.color}
          style={{
            minWidth: '100px',
            flex: '0 0 auto',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: '4px',
            lineHeight: 1,
            textAlign: 'left'
          }}
        >
          <Icon
            name={s.icon}
            style={{
              margin: 0,
              height: '1em',
              lineHeight: '1em',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          />
          <span
            style={{
              height: '1em',
              lineHeight: '1em',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            {s.label}
          </span>
        </Label>

        <div style={{ fontSize: '0.9em', lineHeight: 1.35 }}>
          <strong>{s.label}</strong> — {s.description}
        </div>
      </List.Item>
    ))}
  </List>
);

const CloneStatusLegend = ({
  compact = false,
  iconName = 'info circle',
  title = 'Voice-Clone Status Legend',
  style
}) => {
  if (!compact) {
    return (
      <Segment basic style={style}>
        <Header as="h5" style={{ marginTop: 0 }}>
          <Icon name={iconName} />
          <Header.Content>{title}</Header.Content>
        </Header>
        <LegendRows />
      </Segment>
    );
  }

  return (
    <Popup
      on={['hover', 'click', 'focus']}
      position="bottom left"
      wide
      trigger={
        <span
          tabIndex={0}
          role="button"
          aria-label={title}
          title={title}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            color: '#2185d0',
            ...style
          }}
        >
          <Icon name={iconName} style={{ margin: 0 }} />
        </span>
      }
    >
      <Popup.Header>{title}</Popup.Header>
      <Popup.Content>
        <LegendRows />
      </Popup.Content>
    </Popup>
  );
};

CloneStatusLegend.propTypes = {
  compact: PropTypes.bool,
  iconName: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.object
};

export default CloneStatusLegend;
